import { renderCellExpand } from 'components/Common/GridCell/GridCellExpand';

const columnWidthConfig = {
  'RIT Score': 100,
  'Grade Level': 100,
  'Score Result': 100,
  'Test Subcategory': 150,
};

export const buildColumnsFromData = (dataArray) => {
  if (!dataArray || dataArray.length === 0) return [];

  const firstRow = dataArray[0];

  return Object.keys(firstRow).map((key) => ({
    headerName: key,
    renderCell: renderCellExpand,
    field: key.replace(/\s+/g, ''),
    width: columnWidthConfig[key] || 200,
    valueGetter: (params) => params.row[key],
  }));
};

export const getSsaStudentScoresList = (dataArray) => {
  if (!dataArray || dataArray.length === 0) return [];

  return dataArray.map((item, index) => ({
    id: index + 1,
    ...item,
  }));
};
